/**
 * The non standard order name default suffix
 */
const NON_STANDARD_SUFFIX = "(Non Standard)";

/**
 * Generates a non-standard order name by combining manufacturer, SKU, and non-standard suffix
 *
 * @param {string} manufacturer - The manufacturer name
 * @param {string} sku - The product SKU identifier
 * @return {string} - The formatted non-standard order name
 */
export const nonStandardOrderNameGenerator = (manufacturer: string, sku: string): string =>
    `${manufacturer} - ${sku} ${NON_STANDARD_SUFFIX}`;

/**
 * The ITSE Label used in the ITO order for ITSE
 */
export const ITSE_LABEL = "ITSE";
